<audio controls controlsList="nodownload" style="width:100%" #audioControl oncontextmenu="return false;">
    Your browser does not support the audio element.
</audio>